var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"Calendar",staticClass:"gz-checkups__calendar"},_vm._l((12),function(item,index){return _c('div',{key:index,staticClass:"gz-checkups__calendar__item js-calendar"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }